import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendArrivalChoiceEmail(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.sendArrivalChoiceEmail.url, { id }))
    .post()
}
